import React from 'react';

export type AuthResultTone = 'success' | 'danger' | 'info' | 'loading';

const TONE: Record<AuthResultTone, string> = {
  success: 'bg-success-soft text-success',
  danger: 'bg-danger-soft text-danger',
  info: 'bg-info-soft text-info',
  loading: 'bg-info-soft text-info',
};

const ICON: Record<Exclude<AuthResultTone, 'loading'>, string> = {
  success: 'M5 13l4 4L19 7',
  danger: 'M6 18L18 6M6 6l12 12',
  info: 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
};

interface Props {
  tone: AuthResultTone;
  title: string;
  children?: React.ReactNode;
  /** Botões/links de saída, empilhados abaixo do texto. */
  actions?: React.ReactNode;
}

/** Tela de resultado (e-mail enviado, link inválido, verificação): ícone, título, texto e ações. */
const AuthResult: React.FC<Props> = ({ tone, title, children, actions }) => (
  <div className="text-center" role={tone === 'danger' ? 'alert' : 'status'}>
    <div className={`mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full ${TONE[tone]}`}>
      {tone === 'loading' ? (
        <svg aria-hidden="true" className="h-7 w-7 animate-spin" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.25" strokeWidth="4" />
          <path d="M4 12a8 8 0 018-8" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
        </svg>
      ) : (
        <svg aria-hidden="true" className="h-7 w-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={ICON[tone]} />
        </svg>
      )}
    </div>
    <h2 className="mb-2 text-xl font-bold text-fg">{title}</h2>
    {children && <div className="space-y-3 text-sm text-fg-muted">{children}</div>}
    {actions && <div className="mt-6 space-y-3">{actions}</div>}
  </div>
);

export default AuthResult;
